import React from 'react';
import DataContainer from 'Components/UI/DataContainer';
import PropTypes from 'prop-types';
import useLink from 'Hooks/useLink';
import HouseholdSectionBilling from './HouseholdSectionBilling';


const HouseholdSectionBillingContainer = ({
  relationshipLink,
}) => {
  const {
    isInitializing, loadingError, collection,
  } = useLink(relationshipLink);

  return (
    <DataContainer
      component={HouseholdSectionBilling}
      loading={isInitializing}
      loadingError={loadingError}
      componentProps={{
        collection,
      }}
    />
  );
};

HouseholdSectionBillingContainer.propTypes = {
  relationshipLink: PropTypes.object.isRequired,
};

export default HouseholdSectionBillingContainer;
